import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import api from './Api';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Callback = () => {
  const query = useQuery();
  const code = query.get("code");
  const navigate = useNavigate();
  const [status, setStatus] = useState("Finalizing Integration with eBay...");
  const [done, setDone] = useState(false);

  useEffect(() => {
    const sendCode = async () => {
      const email = localStorage.getItem("userEmail");

      if (!code || !email) {
        setStatus("Missing email or code. Please restart the process.");
        return;
      }

      try {
        const res = await api.post('/ebayGetAuthTokenotherusers', {
          code,
          email,
        });

        setStatus("✅ eBay store successfully connected!");
        setDone(true);
      } catch (error) {
        console.error("Error submitting code:", error);
        setStatus("Failed to complete integration.");
        setDone(true);
      }
    };

    sendCode();
  }, [code]);

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {!done && <div style={styles.loader}></div>}
        <p style={styles.text}>{status}</p>
        {done && (
          <button onClick={() => navigate('/')} style={styles.button}>
            Go to Home
          </button>
        )}
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    height: '100vh',
    background: '#f4f6f8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Inter, sans-serif',
  },
  card: {
    background: '#fff',
    padding: '2rem 3rem',
    borderRadius: '16px',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.05)',
    textAlign: 'center',
  },
  text: {
    marginTop: '1.5rem',
    fontSize: '1.1rem',
    color: '#333',
  },
  loader: {
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #0070f3',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    margin: '0 auto',
    animation: 'spin 0.3s linear infinite', // faster spin
  },
  button: {
    marginTop: '1.5rem',
    padding: '10px 20px',
    backgroundColor: '#0070f3',
    color: '#fff',
    fontSize: '16px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: '0.3s',
  },
};

export default Callback;
